import { writable } from 'svelte/store';

export const lastChange = writable(undefined);
export const activeKommune = writable("");